module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/file-icons/powerpoint.svg?c39417e157cb740244a592e6cb66b916";